import React, { useState, useEffect } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import { useNavigate } from 'react-router-dom';
import DownloadIcon from '@mui/icons-material/Download';
import {
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    Button,
    FormControl,
    Select,
    MenuItem,
    Tabs,
    Tab,
    CardMedia
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';



const priceIndicesFr = [
      {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois de février 2026 ",
        link: "/documents/IndicesPrixConsommation/IPC_Fevrier_2026.pdf",
        description: "L'inflation en moyenne annuelle de février 2026 s'élève à +29,0% contre +31,6% en janvier 2026.",
        date: "2026-02-11",
        datepublication:"2026-03-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    }, 
      {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois de janvier 2026 ",
        link: "/documents/IndicesPrixConsommation/IPC_janvier_2026.pdf",
        description: "L'inflation en moyenne annuelle de janvier 2026 s’élève à +31,6% contre +34,0% en décembre 2025 ",
        date: "2026-01-11",
        datepublication:"2026-02-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    }, 
       {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois de décembre 2025 ",
        link: "/documents/IndicesPrixConsommation/IPC_Dec_2025.pdf",
        description: "L'inflation en glissement annuel en fin décembre 2025 s'élève à +15,2% contre +36,4% en décembre 2024 ",
        date: "2025-12-11",
        datepublication:"2026-01-11",
         image: 'assets/ipc/ipc_1_2025.PNG',
    }, 
     {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois de novembre 2025 ",
        link: "/documents/IndicesPrixConsommation/IPC_Novembre_2025.pdf",
        description: "L'inflation en moyenne annuelle du mois de novembre  2025 s'élève à +36,1% contre +36,8% le mois d'octobre 2025 ",
        date: "2025-11-11",
        datepublication:"2025-12-11",
         image: 'assets/ipc/ipc_1_2025.PNG',
    }, 
     {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois d'octobre 2025 ",
        link: "/documents/IndicesPrixConsommation/IPC_OCT_2025.pdf",
        description: "L'inflation en moyenne annuelle du mois d’octobre 2025 s’élève à +36,8% contre +36,9% le mois de septembre 2025 ",
        date: "2025-10-11",
        datepublication:"2025-11-11",
         image: 'assets/ipc/ipc_1_2025.PNG',
    }, 
       {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois d'octobre 2025 ",
        link: "/documents/IndicesPrixConsommation/IPC_OCT_2025.pdf",
        description: "L'inflation en moyenne annuelle du mois d’octobre 2025 s’élève à +36,8% contre +36,9% le mois de septembre 2025 ",
        date: "2025-09-11",
        datepublication:"2025-10-11",
         image: 'assets/ipc/ipc_1_2025.PNG',
    }, 
       {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois de septembre 2025 ",
        link: "/documents/IndicesPrixConsommation/IPC_Sept_2025.pdf",
        description: "L'inflation en moyenne annuelle du mois de septembre 2025 s'élève à +36,9% contre +36,6% le mois d'aout 2025. ",
        date: "2025-08-11",
        datepublication:"2025-09-11",
         image: 'assets/ipc/ipc_1_2025.PNG',
    }, 
      {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois d'août 2025",
        link: "/documents/IndicesPrixConsommation/IPC_Aout_2025.pdf",
        description: "L'inflation en moyenne annuelle du mois d'août 2025 s'élève à +36,6% contre +35,4% le mois de juillet 2025.",
        date: "2025-08-11",
        datepublication:"2025-09-11",
         image: 'assets/ipc/ipc_1_2025.PNG',
    }, 
         {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois de juillet 2025",
        link: "/documents/IndicesPrixConsommation/IPC_juillet_2025.pdf",
        description: "L'inflation en moyenne annuelle du mois de juillet 2025 s’élève à +35,4% contre +33,8% le mois de juin 2025.",
        date: "2025-07-11",
        datepublication:"2025-08-12",
         image: 'assets/ipc/ipc_1_2025.PNG',
    },  
       {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois de juin 2025",
        link: "/documents/IndicesPrixConsommation/IPC_juin_2025.pdf",
        description: "L'inflation en moyenne annuelle du mois de juin 2025 s'élève à +33,8% contre +31,6% le mois de mai 2025. ",
        date: "2025-06-11",
        datepublication:"2025-07-11",
         image: 'assets/ipc/ipc_1_2025.PNG',
    },
      {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois de mai 2025",
        link: "/documents/IndicesPrixConsommation/IPC_MAI_2025.pdf",
        description: "L’inflation en moyenne annuelle du mois de mai 2025 s’élève à +31,6% contre +29,0% le mois d’avril 2025. ",
        date: "2025-05-11",
        datepublication:"2025-06-10",
         image: 'assets/ipc/ipc_1_2025.PNG',
    },
     {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois d'avril 2025",
        link: "/documents/IndicesPrixConsommation/IPCAVRIL_2025.pdf",
        description: "L’inflation en moyenne annuelle du mois d’avril 2025 s’élève à +29,0% contre +26,1% du mois de mars 2025 ",
        date: "2025-04-11",
        datepublication:"2025-05-10",
         image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois de mars 2025",
        link: "/documents/IndicesPrixConsommation/IPC-MARS_2025.pdf",
        description: "L’inflation en moyenne annuelle du mois de mars 2025 s’élève à +26,1% contre +23,8% du mois de février 2025. ",
        date: "2025-03-11",
        datepublication:"2025-04-10",
         image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois de février 2025",
        link: "/documents/IndicesPrixConsommation/IPC-Fevrier-2025.pdf",
        description: "L’inflation en moyenne annuelle du mois de février 2025 s’élève à +23,8% contre +22,0% du mois de janvier 2025. ",
        date: "2025-02-11",
        datepublication:"2025-03-11",
         image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois de janvier 2025",
        link: "/documents/IndicesPrixConsommation/IPC-janvier_2025.pdf",
        description: "L’inflation en glissement annuel en janvier 2024 s’élève à + 38,1% contre +36,4% en décembre 2024. ",
        date: "2025-01-11",
        datepublication:"2025-02-11",
         image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois de décembre 2024",
        link: "/documents/IndicesPrixConsommation/IPC-decembre_2024vf.pdf",
        description: "L’inflation en glissement annuel à la fin de l’année 2024 (décembre 2024) s’élève à + 36,4% contre +20,2% en décembre 2023. ",
        date: "2024-12-11",
        datepublication: "2025-01-11",
        image: 'assets/ipc/ipc_12_2024.PNG',
    },
      {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois de novembre 2024",
        link: "/documents/IndicesPrixConsommation/IPC-novembre_2024.pdf",
        description: "L’inflation en glissement annuel du mois de novembre 2024 s’élève à + 28,8% contre +24,9% le mois d’octobre 2024. ",
        date: "2024-11-11",
        datepublication: "2024-12-11",
        image: 'assets/ipc/ipc_11_2024.PNG',
    },


    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois d’octobre 2024",
        link: "/documents/IndicesPrixConsommation/IPC-Octobre_2024.pdf",
        description: "L’inflation en glissement annuel du mois d’octobre 2024 s’élève à + 24,9% contre +23,3% le mois de septembre 2024. ",
        date: "2024-10-11",
        datepublication: "2024-11-11",
        image: 'assets/ipc/ipc_10_2024.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois Septembre 2024",
        link: "/documents/IndicesPrixConsommation/IPC-Septembre_2024.pdf",
        description: "L’inflation en glissement annuel du mois de septembre 2024 s’élève à + 23,3% contre +18,2% le mois d’août 2024. ",
        date: "2024-9-11",
        datepublication: "2024-10-11",
        image: 'assets/ipc/ipc_9_2024.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois d’août 2024",
        link: "/documents/IndicesPrixConsommation/IPC-Aout_2024-2.pdf",
        description: "L’inflation en glissement annuel du mois août 2024 s’élève à +18,2% contre +18,6% le mois de juillet 2024.",
        date: "2024-8-11",
        datepublication: "2024-9-11",
        image: 'assets/ipc/ipc_8_2024.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois de Juillet 2024",
        link: "/documents/IndicesPrixConsommation/IPC-Juillet_2024.pdf",
        description: "L’inflation en glissement annuel du mois de juillet 2024 s’élève à +18,6% contre +15,9% le mois de juin 2024. ",
        date: "2024-07-11",
        datepublication: "2024-08-11",
        image: 'assets/ipc/ipc_7_2024.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois de Juin 2024",
        link: "/documents/IndicesPrixConsommation/IPC-Juin_2024.pdf",
        description: "L’inflation en glissement annuel du mois de juin 2024 s’élève à +15,9% contre +12,5% le mois de mai 2024.",
        date: "2024-06-11",
        datepublication: "2024-07-11",
        image: 'assets/ipc/ipc_6_2024.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois de mai 2024",
        link: "/documents/IndicesPrixConsommation/IPC-Mai_2024-1.pdf",
        description: "L’inflation en glissement annuel du mois de mai 2024 s’élève à +12,5% contre +12,1% le mois d’avril 2024.",
        date: "2024-05-11",
        datepublication: "2024-06-11",
        //image: 'assets/ipc/ipc_05_2024.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois d’avril 2024",
        link: "/documents/IndicesPrixConsommation/IPC-Avril-2024-1.pdf",
        description: "L’inflation en glissement annuel du mois d’avril 2024 s’élève à +12,1% contre +14,0% le mois de mars 2024.",
        date: "2024-05-11",
        datepublication: "2024-04-11",
        //image: 'assets/ipc/ipc_05_2024.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de mars 2024",
        link: "/documents/IndicesPrixConsommation/IPC_mars_2024-.pdf",
        description: "L’inflation en glissement annuel du mois de mars 2024 s’élève à +14,0% contre 17,8 % le mois fevrier 2024.  ",
        date: "2024-03-11",
        datepublication: "2024-04-11",
        //image: 'assets/ipc/ipc_3_2024.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de février 2024",
        link: "/documents/IndicesPrixConsommation/IPC-Fevrier024.pdf",
        description: "L’inflation en glissement annuel du mois de février 2024 s’élève à +17,8% contre +17,6% le mois de janvier 2024.",
        date: "2024-02-11",
        datepublication: "2024-03-11",
        //image: 'assets/ipc/ipc_2_2024.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de janvier 2024",
        link: "/documents/IndicesPrixConsommation/ ",
        description: "L’inflation en glissement annuel du mois de janvier 2024 s’élève à +17,6% contre +20,1% le mois de décembre 2023.",
        date: "2024-02-11",
        datepublication: " ",
      //  image: 'assets/ipc/ ',
      //image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de décembre 2023",
        link: "/documents/IndicesPrixConsommation/IPC-Dec-2023.pdf",
        description: "L’inflation en glissement annuel du mois de décembre 2023 s’élève à +20,1% contre 26,6 % du même mois de l’année précédente.",
        date: "2023-12-11",
        datepublication: "2024-01-11",
        //image: 'assets/ipc/ipc_12_2024.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de novembre 2023",
        link: "/documents/IndicesPrixConsommation/IPC-Nov-2023.pdf",
        description: "L’inflation en glissement annuel du mois de novembre 2023 s’élève à +20,4% contre +26,5% du mois précédent.",
        date: "2023-11-11",
        datepublication: "2023-12-11",
        //image: 'assets/ipc/ipc_11_2023.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois d'octobre 2023",
        link: "/documents/IndicesPrixConsommation/IPC-Oct-2023-2-_1_.pdf",
        description: "L’inflation en glissement annuel du mois d’octobre 2023 s’élève à +26,5% contre +26,8% du mois précédent.  ",
        date: "2023-10-11",
        datepublication: "2023-11-11",
        //image: 'assets/ipc/ipc_10_2023.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de septembre 2023",
        link: "/documents/IndicesPrixConsommation/IPC-Sept-2023.pdf",
        description: "L’inflation en glissement annuel du mois de septembre 2023 s’élève à +26,8% contre +28,8% du mois précédent.",
        date: "2023-09-11",
        datepublication: "2023-10-11",
        //image: 'assets/ipc/ipc_9_2023.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois d’août 2023",
        link: "/documents/IndicesPrixConsommation/IPC-Aout2023.pdf",
        description: "L’inflation en glissement annuel du mois d’août 2023 s’élève à +28,8% contre +26,1% du mois précédent. ",
        date: "2023-08-11",
        datepublication: "2023-9-11",
        //image: 'assets/ipc/ipc_8_2023.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de juillet 2023",
        link: "/documents/IndicesPrixConsommation/IPC-juillet-2023.pdf",
        description: "L’inflation en glissement annuel du mois de juillet 2023 s’élève à +26,1% contre +27,1% du mois précédent. ",
        date: "2023-07-11",
        datepublication: "2023-08-11",
       // image: 'assets/ipc/ipc_7_2023.PNG',
       image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de juin 2023",
        link: "/documents/IndicesPrixConsommation/IPC-juin-2023.pdf",
        description: "L’inflation en glissement annuel du mois de juin 2023 s’élève à +27,1% contre +28,9% du mois précédent.",
        date: "2023-06-11",
        datepublication: "2023-07-11",
        //image: 'assets/ipc/ipc_6_2023.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de mai 2023",
        link: "/documents/IndicesPrixConsommation/IPC-mai-2023.pdf",
        description: "L’inflation en glissement annuel du mois de mai 2023 s’élève à +28,9% contre +32,6% du mois précédent.",
        date: "2023-05-11",
        datepublication: "2023-06-11",
        //image: 'assets/ipc/ipc_5_2023.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois d'avril 2023",
        link: "/documents/IndicesPrixConsommation/IPC-avril-2023.pdf",
        description: "L’inflation en glissement annuel du mois d’avril 2023 s’élève à +32,6% comme celui du mois précédent de mars de 32,6%.",
        date: "2023-04-11",
        datepublication: "2023-05-11",
       // image: 'assets/ipc/ipc_4_2023.PNG',
       image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de mars 2023",
        link: "/documents/IndicesPrixConsommation/IPC-Mars-2023.pdf",
        description: "L’inflation en glissement annuel du mois de mars 2023 s’élève à +32,6% contre 28,0% du mois précédent.",
        date: "2023-03-11",
        datepublication: "2023-05-11",
        //image: 'assets/ipc/ipc_3_2023.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de février 2023",
        link: "/documents/IndicesPrixConsommation/IPC-Fevrier-2023.pdf",
        description: "L’inflation en glissement annuel du mois de février 2023 s’élève à +28,0% contre 28,6% du mois précédent.",
        date: "2023-02-11",
        datepublication: "2023-03-11",
        //image: 'assets/ipc/ipc_2_2023.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de décembre 2022",
        link: "/documents/IndicesPrixConsommation/IPC-Dec2022.pdf",
        description: "L’inflation en glissement annuel du mois de décembre 2022 s’élève à +26,6% contre 10,1% du même mois de l’année précédente.  ",
        date: "2022-12-11",
        datepublication: "2023-01-11",
        //image: 'assets/ipc/ipc_12_2022.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de novembre 2022",
        link: "/documents/IndicesPrixConsommation/IPC-Nov-2022.pdf",
        description: "L’inflation en glissement annuel du mois de novembre 2022 s’élève à 5,4% contre une hausse de 1,6% le mois précédent. ",
        date: "2022-11-11",
        datepublication: "2022-12-11",
        //image: 'assets/ipc/ipc_11_2022.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois d'octobre 2022",
        link: "/documents/IndicesPrixConsommation/IPC-Oct-2022.pdf",
        description: "L’inflation en glissement annuel du mois d'octobre 2022 s’élève à  1,6 % contre une hausse de 1,7% le mois précédent. ",
        date: "2022-10-11",
        datepublication: "2022-11-11",
        //image: 'assets/ipc/ipc_10_2022.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de septembre 2022",
        link: "/documents/IndicesPrixConsommation/IPC-Sept-2022.pdf",
        description: "L’inflation en glissement annuel du mois de septembre 2022 s’élève à 1,7 % contre une hausse de 1,0% le mois précédent.",
        date: "2022-09-11",
        datepublication: "2022-10-11",
        //image: 'assets/ipc/ipc_9_2022.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois d'août 2022",
        link: "/documents/IndicesPrixConsommation/IPC-aout-2022.pdf",
        description: "L’inflation en glissement annuel s’élève à  1,0 % contre une hausse de 1,7% le mois précédent. ",
        date: "2022-08-11",
        datepublication: "2022-09-11",
        //image: 'assets/ipc/ipc_8_2022.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de juillet 2022",
        link: "/documents/IndicesPrixConsommation/IPC-Juillet-2022-10.08.2022.pdf",
        description: "L’inflation en glissement annuel s’élève à  1,7% contre une baisse de 0,5% le mois précédent.",
        date: "2022-07-11",
        datepublication: "2022-08-11",
        //image: 'assets/ipc/ipc_7_2022.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },/*
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de juin 2022",
        link: "/documents/IndicesPrixConsommation/ ",
        description: "Ce rapport fournit une estimation des variations de l'indice des prix à la consommation pour le mois de juin 2022, ",
        date: "2022-07-11",
    },*/
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de mai 2022",
        link: "/documents/IndicesPrixConsommation/IPC-mai2022.pdf",
        description: "L’inflation en glissement annuel s’élève à   2,8% contre une hausse de 4,2% le mois précédent.  ",
        date: "2022-05-11",
        datepublication: "2022-06-11",
        //image: 'assets/ipc/ipc_5_2022.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },/*
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois d'avril 2022",
        link: "/documents/IndicesPrixConsommation/ ",
        description: "Ce rapport fournit une estimation des variations de l'indice des prix à la consommation pour le mois d'avril 2022, ",
        date: "2022-05-11",
    },*/
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de mars 2022",
        link: "/documents/IndicesPrixConsommation/IPC-Mrs2022.pdf",
        description: "L’inflation en glissement annuel s’élève à   1,1% contre u 1,8% du mois de février. ",
        date: "2022-03-11",
        datepublication: "2022-04-11",
       // image: 'assets/ipc/ipc_3_2022.PNG',
       image: 'assets/ipc/ipc_1_2025.PNG',
    },
    /*
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de fevrier 2022",
        link: "/documents/IndicesPrixConsommation/IPC-Fevr-20202.pdf",
        description: "Ce rapport fournit une estimation des variations de l'indice des prix à la consommation pour le mois de fevrier 2022, ",
        date: "2022-03-11",
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de janvier 2022",
        link: "/documents/IndicesPrixConsommation/ ",
        description: "Ce rapport fournit une estimation des variations de l'indice des prix à la consommation pour le mois de janvier 2022, ",
        date: "2022-02-11",
    }, */
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de décembre 2021",
        link: "/documents/IndicesPrixConsommation/IPC-Dec2021.pdf",
        description: "L’inflation en glissement annuel s’élève à  1,7% contre une hausse de 1,4% du mois de novembre 2021. ",
        date: "2021-12-11",
        datepublication: "2022-01-11",
        //image: 'assets/ipc/ipc_12_2021.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de novembre 2021",
        link: "/documents/IndicesPrixConsommation/IPC-Nov21.docx",
        description: "L’inflation en glissement annuel s’élève à  1,4% contre 0,5% du mois d’octobre 2021. ",
        date: "2021-11-11",
        datepublication: "2021-12-11",
       // image: 'assets/ipc/ipc_11_2021.PNG',
       image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois d'octobre 2021",
        link: "/documents/IndicesPrixConsommation/IPC-Octobre21.pdf",
        description: "L’inflation en glissement annuel s’élève à  0,5% contre une hausse de 0,6% du mois de septembre 2021. ",
        date: "2021-10-11",
        datepublication: "2021-11-11",
        //image: 'assets/ipc/ipc_10_2021.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    /*
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de septembre 2021",
        link: "/documents/IndicesPrixConsommation/ ",
        description: "Ce rapport fournit une estimation des variations de l'indice des prix à la consommation pour le mois de septembre 2021, ",
        date: "2021-11-11",
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois d'aout 2021",
        link: "/documents/IndicesPrixConsommation/ ",
        description: "Ce rapport fournit une estimation des variations de l'indice des prix à la consommation pour le mois d'aout 2021, ",
        date: "2021-11-11",
    },*/
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de juillet 2021",
        link: "/documents/IndicesPrixConsommation/IPC-juillet21.pdf",
        description: "L’inflation en glissement annuel s’élève à  0,4% contre  0,4% du mois de juin 2021.  ",
        date: "2021-07-11",
        datepublication: "2021-08-11",
       // image: 'assets/ipc/ipc_7_2021.PNG',
       image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de juin 2021",
        link: "/documents/IndicesPrixConsommation/IPC-juin21-.pdf",
        description: "L’inflation en glissement annuel s’élève à   0,4% contre 0,5% du mois de mai 2021. ",
        date: "2021-06-11",
        datepublication: "2021-07-11",
        //image: 'assets/ipc/ipc_6_2021.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de mai 2021",
        link: "/documents/IndicesPrixConsommation/IPC-Mai-2021.pdf",
        description: "L’inflation en glissement annuel s’élève à  0,5% contre 1,4% du mois d’avril 2021",
        date: "2021-05-11",
        datepublication: "2021-06-11",
        //image: 'assets/ipc/ipc_5_2021.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois d'avril 2021",
        link: "/documents/IndicesPrixConsommation/IPC-Avril-2021-corrige.pdf",
        description: "L’inflation en glissement annuel s’élève à 1,2% contre 1,6% du mois de mars 2021. ",
        date: "2021-04-11",
        datepublication: "2021-05-11",
        //image: 'assets/ipc/ipc_4_2021.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de mars 2021",
        link: "/documents/IndicesPrixConsommation/IPC-Mars-2021.pdf",
        description: "L’inflation en glissement annuel s’élève à  2,0% contre une hausse de 0,8% du mois de février 2021. ",
        date: "2021-03-11",
        datepublication: "2021-04-11",
       // image: 'assets/ipc/ipc_3_2021.PNG',
       image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de février 2021",
        link: "/documents/IndicesPrixConsommation/IPC-Fevrier-2021.pdf",
        description: "L’inflation en glissement annuel s’élève à   0,8% contre une baisse de 0,2% du mois de janvier 2021.  ",
        date: "2021-02-11",
        datepublication: "2021-03-11",
        //image: 'assets/ipc/ipc_2_2021.PNG',
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    /*
    {
        title: "Indice des Prix à la Consommation des ménages au Burundi, mois de janvier 2021",
        link: "/documents/IndicesPrixConsommation/ ",
        description: "Ce rapport fournit une estimation des variations de l'indice des prix à la consommation pour le mois de janvier 2021, ",
        date: "2021-02-11",
    },
    */

];

const priceIndicesKi = [
      {
        title: "Igipimo c'ihindagurika ry'ibiciro mu Burundi vy'ivyankenerwa mu miryango :  Ukwezi kwa Ruhuhuma 2026",
        link: "/documents/IndicesPrixConsommation/IPC_Ruhuhuma_2026.pdf",
        description: "Ibiciro  vyo mu Burundi vyiyongereye k’urugero rw’ibice mirongo ibiri n’icenda n’uduce ubusa (29,0%), ugereranije n’umwaka waheze mu kwezi kwa Ruhuhuma 2025.",
        date: "2026-03-13",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
       {
        title: "Igipimo c'ihindagurika ry'ibiciro mu Burundi vy'ivyankenerwa mu miryango :  Ukwezi kwa Nzero 2026",
        link: "/documents/IndicesPrixConsommation/IPC_NZERO_2026.pdf",
        description: "Ibiciro  vyo mu Burundi vyiyongereye k'urugero rw’ibice mirongo itatu na kimwe n’uduce dutandatu kw’ijana(31,6%), ugereranije n’umwaka waheze mu kwezi kwa Nzero 2025.",
        date: "2026-02-13",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
       {
        title: "Igipimo c'ihindagurika ry'ibiciro mu Burundi vy'ivyankenerwa mu miryango :  umwaka wa 2025 ",
        link: "/documents/IndicesPrixConsommation/IPC_Kigarama2025.pdf",
        description: "Ibiciro  vyo mu Burundi vyiyongereye k'urugero rw'ibice mirongo itatu na bine  kw'ijana (34,0%), ugereranije n'umwaka w'i 2024.",
        date: "2025-12-12",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
       {
        title: "Igipimo c'ihindagurika ry'ibiciro mu Burundi vy'ivyankenerwa mu miryango :Ukwezi kwa Munyonyo 2025",
        link: "/documents/IndicesPrixConsommation/IPC_Munyonyo_2025.pdf",
        description: "Ibiciro  vyo mu Burundi vyiyongereye k'urugero rw'ibice mirongo itatu na bitandatu n'agacekamwe kw'ijana (36,1%), ugereranije n'umwaka waheze mu kwezi kwa Munyonyo 2024. ",
        date: "2025-12-12",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
       {
        title: "Igipimo c'ihindagurika ry'ibiciro mu Burundi vy'ivyankenerwa mu miryango :Ukwezi kwa Gitugutu 2025",
        link: "/documents/IndicesPrixConsommation/IPC_Gitugutu_2025.pdf",
        description: "Ibiciro  vyo mu Burundi vyiyongereye k’urugero rw’ibice mirongo itatu na bitandatu n’uduce umunani kw’ijana (36,8%), ugereranije n’umwaka waheze mu kwezi kwa Gitugutu 2024. ",
        date: "2025-11-10",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
      {
        title: "Igipimo c'ihindagurika ry'ibiciro mu Burundi vy'ivyankenerwa mu miryango :Ukwezi kwa Nyakanga 2025",
        link: "/documents/IndicesPrixConsommation/IPC_Nyakanga_2025.pdf",
        description: "Ibiciro vyo mu Burundi vyiyongereye k’urugero rw’ibice mirongo itatu na bitandatu n’uduce icenda kw’ijana (36,9%), ugereranije n’umwaka waheze mu kwezi kwa Nyakanga 2024.  ",
        date: "2025-10-10",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
         {
        title: "Igipimo c'ihindagurika ry'ibiciro mu Burundi vy'ivyankenerwa mu miryango :Ukwezi kwa Myandagaro 2025",
        link: "/documents/IndicesPrixConsommation/IPC_Myandagaro_2025.pdf",
        description: "Ibiciro vyo mu Burundi vyiyongereye k’urugero rw’ibice mirongo itatu na bitandatu n’uduce dutandatu kw’ijana (36,6%), ugereranije n’umwaka waheze mu kwezi kwa Myandagaro 2024. ",
        date: "2025-09-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    
         {
        title: "Igipimo c'ihindagurika ry'ibiciro mu Burundi vy'ivyankenerwa mu miryango :Ukwezi kwa Mukakaro 2025",
        link: "/documents/IndicesPrixConsommation/IPC_Mukakaro_2025.pdf",
        description: "Ibiciro vyo mu Burundi vyiyongereye k’urugero rw’ibice mirongo itatu na bitanu n’uduce tune kw’ijana (35,4%), ugereranije n’umwaka waheze mu kwezi kwa Mukakaro 2025. ",
        date: "2025-08-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    }, 
      {
        title: "Igipimo c'ihindagurika ry'ibiciro mu Burundi vy'ivyankenerwa mu miryango :Ukwezi kwa Ruheshi 2025",
        link: "/documents/IndicesPrixConsommation/IPC_Ruheshi_2025.pdf",
        description: "Ibiciro vyo mu Burundi vyiyongereye k'urugero rw'ibice mirongo itatu na bitatu n'uduce umunani kw'ijana (33,8%), ugereranije n'umwaka waheze mu kwezi kwa Ruheshi 2025.",
        date: "2025-07-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
     {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango :Ukwezi  kwa Rusama 2025",
        link: "/documents/IndicesPrixConsommation/IPC_Rusama_2025.pdf",
        description: "Ibiciro vyo mu Burundi vyiyongereye k’urugero rw’ibice mirongo itatu na rimwe n’uduce dutandatu kw’ijana(31,6%), ugereranije n’umwaka waheze mu kwezi kwa Rusama 2025.",
        date: "2025-06-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
        {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango :Ukwezi kwa Ndamukiza 2025",
        link: "/documents/IndicesPrixConsommation/IPC_Ndamukiza_2025.pdf",
        description: "Ibiciro vyo mu Burundi vyiyongereye k’urugero rw’ibice mirongo ibiri n’icenda kw’ijana(29,0%), ugereranije n’umwaka waheze mu kwezi kwa Ndamukiza 2024. Twokwibutsa ko iryo hinduka ry’ibiciro ku masoko yo mu Burundi ryari k’urugero rw’ibice mirongo ibiri na bitandatu n’agace kamwe kw’ijana(26,1%) muri Ntwarante 2025.",
        date: "2025-05-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
      {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango :Ukwezi kwa a Ntwarante 2025",
        link: "/documents/IndicesPrixConsommation/IPC_Ntwarante_2025.pdf",
        description: "Ibiciro vyo mu Burundi vyiyongereye k’urugero rw’ibice mirongo ibiri na bitandatu n’agace kamwe kw’ijana(26,1%), ugereranije n’umwaka waheze mu kwezi kwa Ntwarante 2024. Twokwibutsa ko iryo hinduka ry’ibiciro ku masoko yo mu Burundi ryari k’urugero rw’ibice mirongo ibiri na bitatu n’uce umunani kw’ijana(23,8%) muri ruhuhuma 2025.",
        date: "2025-04-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
     {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango :Ukwezi kwa Ruhuhuma 2025",
        link: "/documents/IndicesPrixConsommation/IPC-Ruhuhuma-2025.pdf",
        description: "Ibiciro vyo mu Burundi vyiyongereye k’urugero rw’ibice mirongo ibiri na bitatu n’uduce umunani kw’ijana(23,8%), ugereranije n’umwaka waheze mu kwezi kwa Ruhuhuma 2025. Twokwibutsa ko iryo hinduka ry’ibiciro ku masoko yo mu Burundi ryari k’urugero rw’ibice mirongo ibiri na bibiri kw’ijana (22,0%) muri nzero 2025.",
        date: "2025-03-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
  
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango :Ukwezi kwa Nzero 2025",
        link: "/documents/IndicesPrixConsommation/IPC-Nzero-2025.pdf",
        description: "Ibiciro vyo mu Burundi vyiyongereye k’urugero rw’ibice mirongo ibiri na bibiri kw’ijana(22,0%), ugereranije n’umwaka waheze mu kwezi kwa Nzero 2024. Twokwibutsa ko iryo hinduka ry’ibiciro ku masoko yo mu Burundi k’urugero rw’ibice mirongo ibiri d’uduce tubiri kw’ijana (20,2%) mu mwaka waraye uheze wa 2024.",
        date: "2025-02-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : umwaka w’ibihumbi bibiri na mirongo ibiri na kane (2024)",
        link: "/documents/IndicesPrixConsommation/IPC-Kigarama-2024.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 36,4% ugereranije na kigarama y’umwaka wa 2023. Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 20,2% muri kigarama 2023.",
        date: "2025-01-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango :Ukwezi kwa Munyonyo 2024",
        link: "/documents/IndicesPrixConsommation/IPC-Munyonyo-2024.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 28,8%.  Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 24,9% mu kwezi guheze kwa Gitugutu 2024.",
        date: "2024-10-15",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango :Ukwezi kwa Gitugutu 2024",
        link: "/documents/IndicesPrixConsommation/IPC-Gitugutu-2024.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 24,9%. Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 23,3% mu kwezi guheze kwa Gitugutu 2024.",
        date: "2024-11-12",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango :Ukwezi kwa Nyakanga 2024",
        link: "/documents/IndicesPrixConsommation/IPC-Nyakanga-2024.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 23,3%. Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 18,2% mu kwezi guheze kwa Myandagaro 2024.",
        date: "2024-10-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango :Ukwezi kwa Myandagaro 2024",
        link: "/documents/IndicesPrixConsommation/IPC-Myandagaro-2024.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 18,2%. Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 18,6% mu kwezi guheze kwa Mukakaro 2024.  ",
        date: "2024-09-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango :Ukwezi kwa Mukakaro 2024",
        link: "/documents/IndicesPrixConsommation/IPC-Mukakaro-2024.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 18,6%.Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 15,9% mu kwezi guheze kwa Ruheshi 2024.",
        date: "2024-08-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango :Ukwezi kwa Ruheshi 2024",
        link: "/documents/IndicesPrixConsommation/IPC-Ruheshi-2024.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 12,5%. Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 15,9% mu kwezi guheze kwa Rusama 2024.",
        date: "2024-07-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango :Ukwezi kwa Rusama 2024",
        link: "/documents/IndicesPrixConsommation/IPC-Rusama-2024-3.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 12,5%.Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 12,1% mu kwezi guheze kwa Ndamukiza 2024.",
        date: "2024-06-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango :Ukwezi kwa Ndamukiza  2024",
        link: "/documents/IndicesPrixConsommation/IPC-Ndamukiza_2024-4.docx",
        description: "Ibiciro vyiyongereye ku rugero rwa 11,5%. Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 14,0% mu kwezi  guheze kwa  Ntwarante 2024. ",
        date: "2024-05-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango :Ukwezi kwa Ntwarante 2024",
        link: "/documents/IndicesPrixConsommation/IPC-Ntwarante-2024.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 14,0%. Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 17,8% mu kwezi guheze kwa Ruhuhuma 2024.  ",
        date: "2024-04-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango :Ukwezi kwa Ruhuhuma 2024",
        link: "/documents/IndicesPrixConsommation/IPC-Ruhuhuma-2024.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 17,8%. Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 17,6% mu kwezi guheze kwa Nzero 2024.",
        date: "2024-03-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango :Ukwezi kwa Nzero 2024",
        link: "/documents/IndicesPrixConsommation/IPC-Nzero-2024.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 17,6%. Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 20,1% mu kwezi guheze kwa kigarama 2023.  ",
        date: "2024-02-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: " Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : umwaka w’ibihumbi bibiri na mirongo ibiri na gatatu (2023).",
        link: "/documents/IndicesPrixConsommation/IPC-kigarama-2023-1.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 20,1%. Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 26,6% mu kwezi kwa kigarama 2022 ugereranije n’ukwezi kwa kigarama 2021. ",
        date: "2024-01-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Munyonyo 2023.",
        link: "/documents/IndicesPrixConsommation/IPC-Munyonyo-23.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 20,4%. Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 26,5% mu kwezi guheze kwa Gitugutu 2023. ",
        date: "2023-12-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango :ukwezi kwa Gitugutu 2023. ",
        link: "/documents/IndicesPrixConsommation/IPC-Gitugutu-23.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 26,5%.Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 26,8% mu kwezi guheze kwa Nyakanga 2023",
        date: "2023-11-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Nyakanga 2023.",
        link: "/documents/IndicesPrixConsommation/IPC-Nyakanga-23.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 26,8%. Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 28,8% mu kwezi guheze kwa Myandagaro 2023.  ",
        date: "2023-10-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Myandagaro 2023.",
        link: "/documents/IndicesPrixConsommation/IPC-Myandagaro-23.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 28,8%. Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 26,1% mu kwezi guheze kwa Mukakaro 2023.",
        date: "2023-09-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
      {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Mukakaro 2023.",
        link: "/documents/IndicesPrixConsommation/IPC-Mukakaro-23.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 26,1%.Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 27,1% mu kwezi guheze kwa Ruheshi 2023.",
        date: "2023-08-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Ruheshi 2023.",
        link: "/documents/IndicesPrixConsommation/IPC-Ruheshi-23.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 27,1%. Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 28,9% mu kwezi guheze kwa Rusama 2023.",
        date: "2023-07-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Rusama 2023.",
        link: "/documents/IndicesPrixConsommation/IPC-Rusama-23.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 28,9%. Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 32,6% mukwezi guheze kwa Ndamukiza 2023.  ",
        date: "2023-06-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Ndamukiza 2023.",
        link: "/documents/IndicesPrixConsommation/IPC-Ndamukiza-23.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 32,6%. Tukibutsa ko ibiciro vyari ku rugero rumwe rwa 32,6% n’ukwezi guheze kwa Ntwarante 2023.",
        date: "2023-05-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Ntwarante 2023.",
        link: "/documents/IndicesPrixConsommation/IPC-Ntwarante-23.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 32,6%. Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 28,0% mu kwezi kwa Ruhuhuma 2023.  ",
        date: "2023-04-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Ruhuhuma 2023.",
        link: "/documents/IndicesPrixConsommation/IPC-Ruhuhuma-23.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 28,0%. Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 28,6% mu kwezi kwa Nzero 2023  ",
        date: "2023-03-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : umwaka w’ibihumbi bibiri na mirongo ibiri na kabiri (2022).",
        link: "/documents/IndicesPrixConsommation/IPC-kigarama-2022.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 26,6%. Tukibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 10,1% mu kwezi kwa kigarama 2021 ugereranije n’ukwezi kwa kigarama 2020.  ",
        date: "2023-01-12",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: " Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Munyonyo (2022). ",
        link: "/documents/IndicesPrixConsommation/IPC-Munyonyo-22.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 26,8%. Tukabibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 22,1% mu kwezi guheze kwa Gitugutu 2022.   ",
        date: "2022-12-12",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Gitugutu (2022).",
        link: "/documents/IndicesPrixConsommation/IPC-Gitugutu-22.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 22,1%. Tukabibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 20,9% mu kwezi guheze kwa Nyakanga 2022.",
        date: "2022-11-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Nyakanga (2022).",
        link: "/documents/IndicesPrixConsommation/IPC-Nyakanga-22.docx",
        description: "Ibiciro vyiyongereye ku rugero rwa 20,9%. Tukabibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 19,6% mu kwezi guheze kwa Myandagaro 2022.",
        date: "2022-10-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Myandagaro (2022).",
        link: "/documents/IndicesPrixConsommation/IPC-Myandagaro-22.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 19,6%. Tukabibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 19,1% mu kwezi guheze kwa Mukakaro 2022",
        date: "2022-09-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: " Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Mukakaro (2022).",
        link: "/documents/IndicesPrixConsommation/IPC-Mukakaro-22.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 19,1%. Tukabibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 17,6% mu kwezi guheze kwa Ruheshi 2022  ",
        date: "2022-08-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Rusama (2022).",
        link: "/documents/IndicesPrixConsommation/IPC-Rusama-22.docx",
        description: "Ibiciro vyiyongereye ku rugero rwa 18,6%. Tukabibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 16,1% mu kwezi  kwa Ndamukiza 2022.",
        date: "2022-06-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : umwaka w’ibihumbi bibiri na mirongo ibiri na kabiri (2022).",
        link: "/documents/IndicesPrixConsommation/IPC-Ruhuhuma.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 13,4%. Tukabibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 12,3% mu kwezi kwa Nzero 2021.",
        date: "2022-03-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Gitugutu (2021)",
        link: "/documents/IndicesPrixConsommation/IPC-Gitugutu21.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 9,9%. Tukabibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 10,5% mu kwezi guheze kwa Nyakanga 2021.",
        date: "2021-11-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Nyakanga (2021)",
        link: "/documents/IndicesPrixConsommation/IPC-nyakanga-21.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 10,5%. Tukabibutsa ko ibiciro vyari vyiyongereye ku rugero rumwe rwa 10,5% mu kwezi guheze kwa Myandagaro 2021.",
        date: "2021-10-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Myandagaro (2021)",
        link: "/documents/IndicesPrixConsommation/IPC-Myandagaro21.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 10,5%. Tukabibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 9,7% mu kwezi guheze kwa Mukakaro 2021.",
        date: "2021-09-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Mukakaro (2021)",
        link: "/documents/IndicesPrixConsommation/IPC-Mukakaro21.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 9,7%. Tukabibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 9,1% mu kwezi guheze kwa Ruheshi 2021.",
        date: "2021-08-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    {
        title: "Igipimo c’ihindagurika ry’ibiciro mu Burundi vy’ivyankenerwa mu miryango : ukwezi kwa Ndamukiza (2021).",
        link: "/documents/IndicesPrixConsommation/IPC-Ndamukiza-21.pdf",
        description: "Ibiciro vyiyongereye ku rugero rwa 6,4%. Tukabibutsa ko ibiciro vyari vyiyongereye ku rugero rwa 7,8% mu kwezi guheze kwa Ntwarante 2021.",
        date: "2021-07-11",
        image: 'assets/ipc/ipc_1_2025.PNG',
    },
    
    
];


function IndicesPrixConsommation() {
    const [year, setYear] = useState('');
    const [allYears, setAllYears] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [visibleReportsCount, setVisibleReportsCount] = useState(4);
    const navigate = useNavigate(); 

    const handleShowMore = () => {
        setVisibleReportsCount(prevCount => prevCount + 2);
    };

    const handleChangeTab = (event, newValue) => {
        setActiveTab(newValue);
        setYear('');
        setVisibleReportsCount(4);
    };

    useEffect(() => {
        const yearsFr = priceIndicesFr.map(item => new Date(item.date).getFullYear());
        const uniqueYearsFr = [...new Set(yearsFr)].sort((a, b) => b - a);
        setAllYears(uniqueYearsFr);

        const yearsKi = priceIndicesKi.map(item => new Date(item.date).getFullYear());
        const uniqueYearsKi = [...new Set(yearsKi)].sort((a, b) => b - a);
        setAllYears(prev => [...new Set([...prev, ...uniqueYearsKi])]);
    }, []);
    
    const filteredReports = React.useMemo(() => {
        const reportsToFilter = activeTab === 0 ? priceIndicesFr : priceIndicesKi;
        return year ? reportsToFilter.filter(report => new Date(report.date).getFullYear().toString() === year) : reportsToFilter;
    }, [year, activeTab]);

    const allReportsLoaded = visibleReportsCount >= filteredReports.length;

    return (
        <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '20px' }}>
            <NavigationBar />
            <Typography variant="h5" fontWeight="bold" gutterBottom><br /></Typography>
            <Container maxWidth="lg">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <Tabs
                        value={activeTab}
                        onChange={handleChangeTab}
                        textColor="inherit"
                        indicatorColor="secondary"
                    >
                        <Tab label="FRANCAIS" />
                        <Tab label="KIRUNDI" />
                    </Tabs>
                </div>
                
                {activeTab === 0 && ( // Section pour FRANCAIS
                    <div>
                        <Typography variant="h5" align="justify" gutterBottom style={{ color: '#2E7D32' }}>
                            Indices des Prix à la Consommation 
                        </Typography>
                        <Typography variant="body1" align="justify" gutterBottom>   
                                 L'Indice des Prix à la Consommation (IPC) fait actuellement référence à la base 100 de 2016/2017. Il couvre tout le territoire national tant en milieu urbain que rural. Les pondérations dérivent de l’enquête sur les conditions de vie des ménages (ECVMB2013/2014-Volet dépenses). L'IPC montre les données sur la variation des prix des biens et services et permet d'analyser l'inflation et son impact sur le pouvoir d'achat des ménages au fil du temps.

                        </Typography>

                        <FormControl variant="outlined" style={{ marginLeft: '0px', width: '200px' }}> 
                            <Select
                                value={year}
                                onChange={(e) => setYear(e.target.value)}
                                displayEmpty
                            >
                                <MenuItem value="">
                                    <em>Tous les indices</em>
                                </MenuItem>
                                {allYears.map(year => (
                                    <MenuItem key={year} value={year.toString()}>{year}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <Grid container spacing={1} style={{ marginTop: '10px' }}>
                            {filteredReports.slice(0, visibleReportsCount).map((report, index) => (
                                <Grid item xs={12} sm={6} md={12} key={index} style={{ marginBottom: '5px' }}>
                                    <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex' }}>
                                        <CardMedia
                                            component="img"
                                            sx={{ width: 61, height: 90, m: 2, cursor: 'pointer' }}
                                            image={report.image}
                                            alt={report.title}
                                            onClick={() => window.open(report.link, '_blank')}
                                        />
                                        <CardContent style={{ flex: 1, padding: '20px' }}>
                                            <Typography variant="h6" component="div" style={{ fontWeight: 'bold', color: 'green', marginBottom: '10px', cursor: 'pointer' }} onClick={() => window.open(report.link, '_blank')}>
                                            {<DownloadIcon />}{report.title}
                                            </Typography>
                                            <Typography variant="body2" component="div" style={{ marginBottom: '20px' }}>
                                                {report.description}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>

                        {!allReportsLoaded && (
                            <Button onClick={handleShowMore} style={{ marginTop: '20px', backgroundColor: '#2E7D32', color: '#FFFFFF' }}>
                                Plus d'indice
                            </Button>
                        )}
                        
                        {/* NOTE EN FRANCAIS */}
                        <Typography variant="body1" align="justify" paragraph style={{ marginTop: '24px', lineHeight: 1.6 }}>
                            <strong>Note :</strong> Les indices des Prix à la Consommation (IPC) sont publiés le <strong>15 de chaque mois</strong>, soit 15 jours après la clôture du mois précédent.
                            <br /><br />
                            Voici le calendrier des prochaines publications des indices :
                            <ul style={{ listStyleType: 'circle', margin: '10px 0 10px 20px', padding: 0 }}>
                                <li><strong>15 janvier</strong> - Publication des indices du mois de décembre</li>
                                <li><strong>15 février</strong> - Publication des indices du mois de janvier</li>
                                <li><strong>15 mars</strong> - Publication des indices du mois de février</li>
                                <li><strong>15 avril</strong> - Publication des indices du mois de mars</li>
                                <li><strong>15 mai</strong> - Publication des indices du mois d'avril</li>
                                <li><strong>15 juin</strong> - Publication des indices du mois de mai</li>
                                <li><strong>15 juillet</strong> - Publication des indices du mois de juin</li>
                                <li><strong>15 août</strong> - Publication des indices du mois de juillet</li>
                                <li><strong>15 septembre</strong> - Publication des indices du mois d'août</li>
                                <li><strong>15 octobre</strong> - Publication des indices du mois de septembre</li>
                                <li><strong>15 novembre</strong> - Publication des indices du mois d'octobre</li>
                                <li><strong>15 décembre</strong> - Publication des indices du mois de novembre</li>
                            </ul>
                        </Typography>
                        
                        <Button onClick={() => navigate('/indice')} style={{ marginTop: '20px', backgroundColor: '#2E7D32', color: '#FFFFFF' }}>
                            <ArrowBackIcon style={{ marginRight: '8px' }} />
                            Retour à la page des indices
                        </Button>
                    </div>
                )}
                
                {activeTab === 1 && ( // Section pour KIRUNDI
                    <div>
                        <Typography variant="h5" align="justify" gutterBottom style={{ color: '#2E7D32' }}>
                            Igipimo c’ihindagurika ry’ibiciro
                        </Typography>
                        <Typography variant="body1" align="justify" gutterBottom>
                            Iki kigabane gitanga raporo y'Ibiciro (IPC) mu Burundi, kikerekana itandukaniro riri hagati y'ibiciro vy'ibintu n'ibindi bikorwa. Aya makuru afasha mu gusesangura ukwiyongera kw'ibiciro hamwe n'ingaruka zavyo ku bushobozi bwo kugura.
                        </Typography>
                     
                        <FormControl variant="outlined" style={{ marginLeft: '0px', width: '200px' }}>
                            <Select
                                value={year}
                                onChange={(e) => setYear(e.target.value)}
                                displayEmpty
                            >
                                <MenuItem value="">
                                    <em> Ibipimo vyose</em>
                                </MenuItem>
                                {allYears.map(year => (
                                    <MenuItem key={year} value={year.toString()}>{year}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    
                        <Grid container spacing={1} style={{ marginTop: '10px' }}>
                            {filteredReports.slice(0, visibleReportsCount).map((report, index) => (
                                <Grid item xs={12} sm={6} md={12} key={index} style={{ marginBottom: '5px' }}>
                                    <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex' }}>
                                        <CardMedia
                                            component="img"
                                            sx={{ width: 91, height: 140, m: 2, cursor: 'pointer' }}
                                            image={report.image}
                                            alt={report.title}
                                            onClick={() => window.open(report.link, '_blank')}
                                        />
                                        <CardContent style={{ flex: 1, padding: '20px' }}>
                                            <Typography variant="h6" component="div" style={{ fontWeight: 'bold', color: 'green', marginBottom: '10px', cursor: 'pointer' }} onClick={() => window.open(report.link, '_blank')}>
                                            {<DownloadIcon />}{report.title}
                                            </Typography>
                                            <Typography variant="body2" component="div" style={{ marginBottom: '20px' }}>
                                                {report.description}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>

                        {!allReportsLoaded && (
                            <Button onClick={handleShowMore} style={{ marginTop: '20px', backgroundColor: '#2E7D32', color: '#FFFFFF' }}>
                               Ibindi bipimo 
                            </Button>
                        )}

                        {/* NOTE EN KIRUNDI */}
                        <Typography variant="body1" align="justify" paragraph style={{ marginTop: '24px', lineHeight: 1.6 }}>
                            <strong>Menya neza :</strong> Igipimo cihindagurika ry'Ibiciro(IPC) cama gisohoka kuwa <strong>15 buri kwezi</strong>, canke imisi 15 inyuma y'ukwezi kurangiye. Iki kirangamisi cemeza ko amakuru akenewe yamaho, bigafasha mu gukurikirana iterambere ry'ibiciro muri urwo rwego. 
                            <br /><br />
                            Raba ikirangamisi c'aho ibipimo bizosohokera mu gihe c'imbere :
                            <ul style={{ listStyleType: 'circle', margin: '10px 0 10px 20px', padding: 0 }}>
                                <li><strong>15 Nzero</strong> - Gusohora Igipimo c'ukwezi kwa Kigarama</li>
                                <li><strong>15 Ruhuhuma</strong> - Gusohora Igipimo c'ukwezi kwa Nzero</li>
                                <li><strong>15 Ntwarante</strong> - Gusohora Igipimo c'ukwezi kwa Ruhuhuma</li>
                                <li><strong>15 Ndamukiza</strong> - Gusohora Igipimo c'ukwezi kwa Ntwarante</li>
                                <li><strong>15 Rusama</strong> - Gusohora Igipimo c'ukwezi kwa Ndamukiza</li>
                                <li><strong>15 Rusama</strong> - Gusohora Igipimo c'ukwezi kwa Rusama</li>
                                <li><strong>15 Mukakaro</strong> - Gusohora Igipimo c'ukwezi kwa Kamena</li>
                                <li><strong>15 Mukakaro</strong> - Gusohora Igipimo c'ukwezi kwa Mukakaro</li>
                                <li><strong>15 Nyakanga</strong> - Gusohora Igipimo c'ukwezi kwa Mukakaro</li>
                                <li><strong>15 Gitugutu</strong> - Gusohora Igipimo c'ukwezi kwa Nyakanga</li>
                                <li><strong>15 Munyonyo</strong> - Gusohora Igipimo c'ukwezi kwa Gitugutu</li>
                                <li><strong>15 Kigarama</strong> - Gusohora Igipimo c'ukwezi kwa Munyonyo</li>
                            </ul>
                        </Typography>
                        
                        <Button onClick={() => navigate('/indice')} style={{ marginTop: '20px', backgroundColor: '#2E7D32', color: '#FFFFFF' }}>
                            <ArrowBackIcon style={{ marginRight: '8px' }} />Subira kuri page y'ibipimo
                        </Button>
                    </div>
                )}
            </Container>
            <br />
            <br />
            <Footer />
        </div>
    );
}

export default IndicesPrixConsommation;